import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            showStaticContent: false,
            wysiwygComponent: null
        }
    },

    computed: {
        ...mapGetters('Auth', ['isAdmin']),
    },

    created () {
        if (this.isAdmin) {
            if (document.querySelector('html').classList.contains('ie11')) {
                /*
                    If IE, we have have to either add the fallback on "Create New" pages letting
                    the user know they must update their browser.

                    If it's an already existing page, we need to render the static content.
                */
                if (this.isNewPage) this.wysiwygComponent = 'Ie11Fallback'
                else {
                    this.wysiwygComponent = 'Ie11Banner'
                    this.showStaticContent = true
                }
            } else {
                // If not IE, we can use the wysiwyg editor
                this.wysiwygComponent = () => import('@/modernBrowserComponents/WysiwygEditor.vue')
            }
        } else {
            this.showStaticContent = true
        }
    }
}
